import { useOnEventOutside } from "./use-on-event-outside.es.js";
const useOnClickOutside = (refs, handler) => useOnEventOutside(refs, ["mousedown", "touchstart"], handler);
export {
  useOnClickOutside
};
